import useDiscard from "../../../useDiscard";
import useWeakMap from "../../../utils/useWeakMap";
import { isLayer } from "../validator/useLayerIdentity";
import useLogStack from "../../utils/useLogStack";

const store = useWeakMap();

const onDiscardlayer = (layer, originalSource, copySource) => {
    if (store.has(originalSource)) {
        store.get(originalSource).delete(layer);
    }
}

export const storeLayerUsingOriginalSource = (originalSource, layer, key = '') => {
    if (!store.has(originalSource)) {
        store.set(originalSource, new Set());
    }
    useLogStack('storeLayerUsingOriginalSource', layer, originalSource );
    store.get(originalSource).add(layer);
    useDiscard(layer, onDiscardlayer)
}

/**
 * 
 * 
 * @param {object} originalSource 
 * @returns {Map<string,typeof Proxy> | undefined}
 */
const useQueryLayerUsingOriginalSource = (originalSource) => {
    return store.get(originalSource);
}

export const deleteLayerUsingOriginalSource = (originalSource, refLayer) => {
    if (!store.has(originalSource)) return;
    useLogStack("deleteLayerUsingOriginalSource", refLayer, originalSource )
    store.get(originalSource).delete(refLayer);
}

export default useQueryLayerUsingOriginalSource;